(() => {
  const key = document.currentScript?.dataset.key;
  if (!key) return;
  let started = false;
  const update = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    const allowed = privacy.analyticsProcessingAllowed() === true;
    if (!allowed) {
      if (started) window.location.reload();
      return;
    }
    if (started) return;
    started = true;
    const tracker = document.createElement('script');
    tracker.src = 'https://analytics.ahrefs.com/analytics.js';
    tracker.dataset.key = key;
    tracker.async = true;
    document.head.appendChild(tracker);
  };
  document.addEventListener('visitorConsentCollected', update);
  if (window.Shopify?.customerPrivacy) {
    update();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) update();
    });
  }
})();
